var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#92A0AF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C8.096 2.5 2.5 8.096 2.5 15S8.096 27.5 15 27.5 27.5 21.904 27.5 15 21.904 2.5 15 2.5zM15 1c7.732 0 14 6.268 14 14s-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.458 9.754c0 .483-.166.896-.5 1.235a1.619 1.619 0 01-1.203.511c-.47 0-.873-.17-1.21-.511a1.691 1.691 0 01-.504-1.235c0-.483.168-.896.504-1.24A1.63 1.63 0 0115.755 8c.47 0 .87.172 1.204.514.333.344.5.757.5 1.24zm-.167 11.507c-.5.24-.901.424-1.2.55a2.654 2.654 0 01-1.04.189c-.607 0-1.079-.18-1.416-.54-.336-.36-.505-.818-.505-1.372 0-.215.013-.435.038-.66.025-.225.066-.48.122-.763l.626-2.696c.056-.259.103-.504.141-.735.039-.23.057-.441.057-.632 0-.344-.058-.585-.175-.72-.117-.136-.34-.205-.67-.205a1.47 1.47 0 00-.498.093c-.17.061-.271-.656-.271-.656.41-.203.803-.377 1.178-.522.375-.144.73-.217 1.065-.217.603 0 1.068.177 1.394.532.327.354.49.814.49 1.38 0 .118-.01.324-.033.62a4.956 4.956 0 01-.126.813l-.624 2.686a8.99 8.99 0 00-.137.74 4.616 4.616 0 00-.06.628c0 .357.064.6.196.73s.36.194.682.194c.152 0 .324-.033.516-.097.192-.065.25.66.25.66z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/Ic_info.0600e987f68f4cd6dd6a6bc186b85187.svg";
export { ForwardRef as ReactComponent };